import { render, staticRenderFns } from "./TemplatePreviewModal.vue?vue&type=template&id=52118bef&scoped=true&"
import script from "./TemplatePreviewModal.vue?vue&type=script&lang=js&"
export * from "./TemplatePreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52118bef",
  null
  
)

export default component.exports